import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { Saga } from 'custom-types/saga';
import * as MetricDefinitionsAPI from 'api/MetricDefinitionsAPI';
import { ActionTypes } from './actionTypes';
import * as actions from './actions';
import { MetricDefinition } from './types';

type MetricDefinitionsSaga = Saga<
  actions.MetricDefinitionsAction<Record<string, unknown>, actions.Payload>
>;
type Params = { request: any; type: string };
/**
 * fetchAnalyticsMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* fetchAnalyticsMetricDefinitionsSaga({ request }: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.getAnalyticsMetricDefinitions,
      request,
    );
    const { data } = response;
    yield put(actions.fetchAnalyticsMetricDefinitionsResponse(data));
  } catch (error) {
    yield put(actions.fetchAnalyticsMetricDefinitionsError());
  }
}

/**
 * updateAnalyticsMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* updateAnalyticsMetricDefinitionsSaga({ request }: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.updateAnalyticsMetricDefinition,
      request,
    );
    const { data } = response;
    yield put(actions.updateAnalyticsMetricDefinitionResponse(data));
    yield put(actions.fetchAnalyticsMetricDefinitions(''));
  } catch (error) {
    yield put(actions.updateAnalyticsMetricDefinitionError());
  }
}

/**
 * createAnalyticsMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* createAnalyticsMetricDefinitionsSaga({ request }: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.createAnalyticsMetricDefinition,
      request,
    );
    const { data } = response;
    yield put(actions.createAnalyticsMetricDefinitionResponse(data));
    yield put(actions.fetchAnalyticsMetricDefinitions(''));
  } catch (error) {
    yield put(actions.createAnalyticsMetricDefinitionError());
  }
}

/**
 * updateAnalyticsMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* bulkUpdateAnalyticsMetricDefinitionsSaga({
  request,
}: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.bulkUpdateAnalyticsMetricDefinition,
      request,
    );
    const { data } = response;
    yield put(actions.bulkUpdateAnalyticsMetricDefinitionResponse(data));
    yield put(actions.fetchAnalyticsMetricDefinitions(''));
  } catch (error) {
    yield put(actions.bulkUpdateAnalyticsMetricDefinitionError());
  }
}

/**
 * deleteAnalyticsMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* deleteAnalyticsMetricDefinitionsSaga({ request }: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.deleteAnalyticsMetricDefinition,
      request,
    );
    const { data } = response;
    yield put(actions.deleteAnalyticsMetricDefinitionResponse(data));
    yield put(actions.fetchAnalyticsMetricDefinitions(''));
  } catch (error) {
    yield put(actions.deleteAnalyticsMetricDefinitionError());
  }
}

/**
 * fetchHighLevelMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* fetchHighLevelMetricDefinitionsSaga({ request }: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.getHighLevelMetricDefinitions,
      request,
    );
    const { data } = response;
    yield put(actions.fetchHighLevelMetricDefinitionsResponse(data));
  } catch (error) {
    yield put(actions.fetchHighLevelMetricDefinitionsError());
  }
}

/**
 * updateHighLevelMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* updateHighLevelMetricDefinitionsSaga({ request }: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.updateHighLevelMetricDefinition,
      request,
    );
    const { data } = response;
    yield put(actions.updateHighLevelMetricDefinitionResponse(data));
    yield put(actions.fetchHighLevelMetricDefinitions(''));
  } catch (error) {
    yield put(actions.updateHighLevelMetricDefinitionError());
  }
}

/**
 * createHighLevelMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* createHighLevelMetricDefinitionsSaga({ request }: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.createHighLevelMetricDefinition,
      request,
    );
    const { data } = response;
    yield put(actions.createHighLevelMetricDefinitionResponse(data));
    yield put(actions.fetchHighLevelMetricDefinitions(''));
  } catch (error) {
    yield put(actions.createHighLevelMetricDefinitionError());
  }
}

/**
 * updateHighLevelMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* bulkUpdateHighLevelMetricDefinitionsSaga({
  request,
}: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.bulkUpdateHighLevelMetricDefinition,
      request,
    );
    const { data } = response;
    yield put(actions.bulkUpdateHighLevelMetricDefinitionResponse(data));
    yield put(actions.fetchHighLevelMetricDefinitions(''));
  } catch (error) {
    yield put(actions.bulkUpdateHighLevelMetricDefinitionError());
  }
}

/**
 * deleteHighLevelMetricDefinitions
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export function* deleteHighLevelMetricDefinitionsSaga({ request }: Params): MetricDefinitionsSaga {
  try {
    const response: { data: MetricDefinition[] } = yield call(
      MetricDefinitionsAPI.deleteHighLevelMetricDefinition,
      request,
    );
    const { data } = response;
    yield put(actions.deleteHighLevelMetricDefinitionResponse(data));
    yield put(actions.fetchHighLevelMetricDefinitions(''));
  } catch (error) {
    yield put(actions.deleteHighLevelMetricDefinitionError());
  }
}

addToRootSaga([
  takeLatest(
    ActionTypes.FETCH_ANALYTICS_METRIC_DEFINITIONS_REQUEST,
    fetchAnalyticsMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.UPDATE_ANALYTICS_METRIC_DEFINITION_REQUEST,
    updateAnalyticsMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.CREATE_ANALYTICS_METRIC_DEFINITION_REQUEST,
    createAnalyticsMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.BULK_UPDATE_ANALYTICS_METRIC_DEFINITION_REQUEST,
    bulkUpdateAnalyticsMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.DELETE_ANALYTICS_METRIC_DEFINITION_REQUEST,
    deleteAnalyticsMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.FETCH_HIGH_LEVEL_METRIC_DEFINITIONS_REQUEST,
    fetchHighLevelMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.UPDATE_HIGH_LEVEL_METRIC_DEFINITION_REQUEST,
    updateHighLevelMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.CREATE_HIGH_LEVEL_METRIC_DEFINITION_REQUEST,
    createHighLevelMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.BULK_UPDATE_HIGH_LEVEL_METRIC_DEFINITION_REQUEST,
    bulkUpdateHighLevelMetricDefinitionsSaga,
  ),
  takeLatest(
    ActionTypes.DELETE_HIGH_LEVEL_METRIC_DEFINITION_REQUEST,
    deleteHighLevelMetricDefinitionsSaga,
  ),
]);
